module.exports = __webpack_public_path__ + "static/media/logo-palmeirais.612b19b4.png";